module.exports = __webpack_public_path__ + "img/travel-assistance.121fcde0.jpg";